<template>
  <div>
    <div
      class="mb-3"
      style="width: 100%"
      v-loading="loading"
      :element-loading-text="loadingText"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <el-form ref="form">
        <div class="!p-3 !border !border-page-border rounded-xl">
          <div class="navbar-align">
            <p class="text-[13px] xl:text-sm 2xl:text-base text-black-950 !font-normal !m-0">
              Actions
            </p>
            <el-button
              @click="addAction"
              style="background: var(--brand-500) !important"
              class="!text-white !border-brand-500 !px-4 !py-2 !rounded-md text-xs 2xl:text-smd"
              icon="el-icon-plus"
              size="mini"
              type="primary"
            >
              Add
            </el-button>
          </div>

          <div>
            <el-row :gutter="20" v-for="(action, i) in actions" :key="i" class="action-row mt-2">
              <el-col :span="3">
                <el-input v-model="action.action_button_label" placeholder="Enter button label" />
              </el-col>

              <el-col :span="4">
                <el-select
                  placeholder="Select type"
                  v-model="action.action_button_action_type"
                  style="width: 100%"
                  @change="handleActionTypeChange(action)"
                  clearable
                >
                  <el-option
                    v-for="(type, index) of actionTypes"
                    :key="index"
                    :label="type.label"
                    :value="type.value"
                  />
                </el-select>
              </el-col>

              <el-col :span="4" v-if="action.action_button_action_type">
                <el-select
                  placeholder="Select navigation"
                  v-model="action.action_button_action_navigation_type"
                  style="width: 100%"
                >
                  <el-option
                    v-for="(type, index) of navigationTypes"
                    :key="index"
                    :label="type.label"
                    :value="type.value"
                  />
                </el-select>
              </el-col>

              <el-col :span="4" v-if="action.action_button_action_navigation_type">
                <el-select
                  placeholder="Select location"
                  v-model="action.action_button_target_location"
                  style="width: 100%"
                >
                  <el-option
                    v-for="(type, index) of locationTypes"
                    :key="index"
                    :label="type.label"
                    :value="type.value"
                  />
                </el-select>
              </el-col>

              <el-col :span="4" v-if="action.action_button_action_navigation_type === 'OPEN_URL'">
                <el-input v-model="action.action_button_target_link" placeholder="Enter url" />
                <span
                  style="color: red"
                  v-if="
                    action.action_button_target_link &&
                    !isValidURL(action.action_button_target_link)
                  "
                >
                  Invalid URL
                </span>
              </el-col>

              <el-col :span="1" v-if="action.action_button_action_type">
                <el-tooltip content="Pick Button Background Color" placement="top">
                  <el-color-picker v-model="action.button_color" size="mini" />
                </el-tooltip>
              </el-col>

              <el-col :span="1" v-if="action.action_button_action_type">
                <el-tooltip content="Pick Button Text Color" placement="top">
                  <el-color-picker v-model="action.text_color" size="mini" />
                </el-tooltip>
              </el-col>

              <el-col :span="2" class="text-center" v-if="action.action_button_action_type">
                <el-switch
                  v-model="action.is_active"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                />
              </el-col>

              <el-col :span="1" class="text-center">
                <el-link type="danger" :underline="false" @click="removeAction(i)">
                  <i class="el-icon-delete !text-xl"></i>
                </el-link>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="card-footer !border-none !bg-transparent flex justify-start !mt-4 !pl-0">
          <el-form-item>
            <el-button
              style="background: var(--brand-500) !important"
              class="!text-white !border-brand-500 !px-5 !py-2.5 !rounded-md text-xs 2xl:text-mds"
              type="button"
              @click="onSubmit"
              :disabled="checkDisabled"
            >
              Save
            </el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'Action-Button',
    data() {
      return {
        companyDetails: {},
        loading: false,
        loadingText: 'Loading...',
        actions: [],
        savedActions: [],

        actionTypes: [{ value: 'NAVIGATION', label: 'Navigation' }],

        navigationTypes: [{ value: 'OPEN_URL', label: 'Open URL' }],

        locationTypes: [
          { value: 'SELF', label: 'Same Page' },
          { value: 'NEW_TAB', label: 'New Tab' },
          { value: 'NEW_WINDOW', label: 'New Window' },
        ],
      };
    },
    mounted() {
      if (this.getCompanyDetails) {
        this.savedActions = this.getCompanyDetails.action_buttons || [];
        this.actions = [...this.savedActions];
        this.companyDetails = this.getCompanyDetails;
      }
    },
    computed: {
      ...mapGetters('company', ['getCompanyDetails', 'getUpdateCompany']),
      checkDisabled() {
        return this.actions.some(
          (a) =>
            !a.action_button_label ||
            !a.action_button_action_type ||
            !a.action_button_action_navigation_type ||
            !a.action_button_target_location ||
            (a.action_button_action_navigation_type === 'OPEN_URL' &&
              (!a.action_button_target_link || !this.isValidURL(a.action_button_target_link)))
        );
      },
    },
    methods: {
      addAction() {
        if (this.actions.length >= 3) {
          this.$message.warning('You can only add up to 3 action buttons.');
          return;
        }

        this.actions.push({
          action_label: '',
          action_button_action_type: '',
          action_button_action_navigation_type: '',
          action_button_target_location: '',
          action_button_target_link: '',
        });
      },
      removeAction(index) {
        this.actions.splice(index, 1);
      },
      handleActionTypeChange(action) {
        if (action.action_button_action_type !== 'NAVIGATION') {
          action.action_button_action_navigation_type = '';
          action.action_button_target_location = '';
          action.action_button_target_link = '';
        }
      },
      isValidURL(url) {
        let re = /[-a-zA-Z0-9@:%_+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_+.~#?&//=]*)?/gi;
        if (re.test(url)) {
          return true;
        } else {
          return false;
        }
      },
      async onSubmit() {
        this.loading = true;
        try {
          this.companyDetails['action_buttons'] = this.actions;
          if (this.companyDetails?._id) {
            await this.$store.dispatch('company/updateCompany', this.companyDetails);

            if (this.getUpdateCompany.success) {
              await this.$store.dispatch('company/fetchCompany', this.companyDetails._id);
              this.savedActions = [...this.getCompanyDetails.action_buttons];
              this.actions = [...this.savedActions];

              this.$notify.success({
                title: 'Success',
                message: 'Actions updated successfully',
              });
            } else {
              this.$notify.error({
                title: 'Error',
                message: this.getUpdateCompany.message,
              });
            }
          }
        } catch (err) {
          console.error('Error saving actions:', err);
          this.$notify.error({
            title: 'Error',
            message: 'Something went wrong while saving actions',
          });
        } finally {
          this.loading = false;
        }
      },
    },
  };
</script>

<style scoped>
  .navbar-align {
    display: flex !important;
    justify-content: space-between !important;
  }
</style>
